"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractDestroyable = void 0;
var Burden_1 = require("./Burden");
/**
 * Provides an abstract base class for Destroyable implementations.
 */
var AbstractDestroyable = /** @class */ (function () {
    function AbstractDestroyable() {
        this.isDestroyed = false;
        this.burdens = [];
    }
    /**
     * Destroys this object, releasing any resources it holds and rendering it unusable.
     */
    AbstractDestroyable.prototype.destroy = function () {
        this.guardDestroyed();
        this.isDestroyed = true;
        Burden_1.Burden.resolveAll(this.burdens);
        this.burdens.splice(0, this.burdens.length);
    };
    /**
     * Indicates whether or not this object has been destroyed.
     */
    AbstractDestroyable.prototype.destroyed = function () {
        return this.isDestroyed;
    };
    /**
     * Throws an exception if this object has been destroyed.  Call this before operations that should be prevented
     * on a destroyed object.
     */
    AbstractDestroyable.prototype.guardDestroyed = function () {
        if (this.isDestroyed) {
            throw new Error('This object has been destroyed.');
        }
    };
    /**
     * Burdens this Destroyable with the specified Burden compatible entities.  These burden entities will be destroyed,
     * canceled or invoked when this object is destroyed.
     *
     * @param objects the Destroyable objects
     */
    AbstractDestroyable.prototype.burden = function () {
        var entities = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            entities[_i] = arguments[_i];
        }
        this.burdens = this.burdens.concat(entities);
    };
    return AbstractDestroyable;
}());
exports.AbstractDestroyable = AbstractDestroyable;
